import React, { useState, useEffect, useRef, useCallback } from 'react';
import RotatingBorderCircles from '../components/AnimatedBlurBg'
import ParticleGrid from '../components/AnimatedGridBg'
import ScrollNudger from '../components/LookFurther'

const Footer = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://instagram.com/yourusername',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44 1.44-.645 1.44-1.44-.644-1.44-1.44-1.44z"/>
        </svg>
      )
    },
    {
      name: 'WhatsApp',
      url: 'https://wa.me/yourphonenumber',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      )
    },
    {
      name: 'LinkedIn',
      url: 'https://linkedin.com/in/yourusername',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0h2.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    {
      name: 'GitHub',
      url: 'https://github.com/yourusername',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      )
    },
    {
      name: 'Email',
      url: 'mailto:your.email@example.com',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-10 5L2 7"/>
        </svg>
      )
    }
  ];

  return (
    <footer style={{
      display: 'flex',
      justifyContent: 'flex',
      alignItems: 'center',
      background: '#ebe9dd'
    }}>
      <div style={{
        margin:'10px',
        border: '2px solid #333',
        borderRadius: '8px',
        padding: '5px',
        display: 'flex',
        gap: '30px',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%'
      }}>
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '2px 4px',
              border: '0px solid #666',
              borderRadius: '20px',
              textDecoration: 'none',
              color: '#333',
              fontSize: '10px',
              transition: 'all 0.3s ease',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f0f0f0';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {link.icon}
            <span>{link.name}</span>
          </a>
        ))}
      </div>
    </footer>
  );
};

// Device detection hook
const useDeviceDetection = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const checkTouchDevice = () => {
      const hasTouch = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0 ||
        window.matchMedia('(pointer: coarse)').matches
      );
      
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      setIsTouchDevice(hasTouch || isMobileUserAgent);
    };

    checkTouchDevice();
    
    const mediaQuery = window.matchMedia('(pointer: coarse)');
    const handleChange = () => checkTouchDevice();
    
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  return isTouchDevice;
};

// Desktop/Mouse Interactive Portfolio Item
const SingleInteractivePortfolioItem = ({ 
  data = { title: "Project 1", subtitle: "website", projectUrl: "#" },
  onProjectOpen,
  force = 25,
  falloff = 300
}) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isMouseInside, setIsMouseInside] = useState(false);
  const [titleCharPositions, setTitleCharPositions] = useState([]);
  const [subtitleCharPositions, setSubtitleCharPositions] = useState([]);
  const [openProjectCharPositions, setOpenProjectCharPositions] = useState([]);
  const containerRef = useRef(null);
  const titleCharsRef = useRef([]);
  const subtitleCharsRef = useRef([]);
  const openProjectCharsRef = useRef([]);

  const handleProjectOpen = (e) => {
    e.stopPropagation();
    if (data.projectUrl) {
      if (onProjectOpen) {
        onProjectOpen(data.projectUrl);
      } else {
        window.open(data.projectUrl, '_blank');
      }
    }
  };

  // Initialize character positions
  useEffect(() => {
    const updateCharPositions = () => {
      if (!containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      
      const titlePositions = titleCharsRef.current.map((charRef) => {
        if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
        const rect = charRef.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2 - containerRect.left;
        const centerY = rect.top + rect.height / 2 - containerRect.top;
        return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
      });

      const subtitlePositions = subtitleCharsRef.current.map((charRef) => {
        if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
        const rect = charRef.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2 - containerRect.left;
        const centerY = rect.top + rect.height / 2 - containerRect.top;
        return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
      });

      const openProjectPositions = openProjectCharsRef.current.map((charRef) => {
        if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
        const rect = charRef.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2 - containerRect.left;
        const centerY = rect.top + rect.height / 2 - containerRect.top;
        return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
      });

      setTitleCharPositions(titlePositions);
      setSubtitleCharPositions(subtitlePositions);
      setOpenProjectCharPositions(openProjectPositions);
    };

    setTimeout(updateCharPositions, 100);
    window.addEventListener('resize', updateCharPositions);
    return () => window.removeEventListener('resize', updateCharPositions);
  }, [data.title, data.subtitle]);

  // Handle mouse movement
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const mouseX = e.clientX - containerRect.left;
      const mouseY = e.clientY - containerRect.top;
      
      setMousePos({ x: mouseX, y: mouseY });

      if (!isMouseInside) return;

      const updatePositions = (positions, setPositions, forceMultiplier) => {
        setPositions(prev => prev.map(pos => {
          const dx = mouseX - pos.baseX;
          const dy = mouseY - pos.baseY;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          const maxDistance = falloff;
          const maxOffset = force * forceMultiplier;
          
          if (distance < maxDistance && distance > 0) {
            const strength = 1 - (distance / maxDistance);
            const offsetX = (dx / distance) * strength * maxOffset;
            const offsetY = (dy / distance) * strength * maxOffset;
            
            return { ...pos, x: pos.baseX + offsetX, y: pos.baseY + offsetY };
          }
          
          return { ...pos, x: pos.baseX, y: pos.baseY };
        }));
      };

      updatePositions(titleCharPositions, setTitleCharPositions, 1);
      updatePositions(subtitleCharPositions, setSubtitleCharPositions, 0.8);
      updatePositions(openProjectCharPositions, setOpenProjectCharPositions, 0.6);
    };

    const handleMouseEnter = () => setIsMouseInside(true);
    const handleMouseLeave = () => {
      setIsMouseInside(false);
      setTitleCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
      setSubtitleCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
      setOpenProjectCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('mousemove', handleMouseMove);
      container.addEventListener('mouseenter', handleMouseEnter);
      container.addEventListener('mouseleave', handleMouseLeave);
      
      return () => {
        container.removeEventListener('mousemove', handleMouseMove);
        container.removeEventListener('mouseenter', handleMouseEnter);
        container.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [isMouseInside, titleCharPositions.length, subtitleCharPositions.length, openProjectCharPositions.length, force, falloff]);

  const titleChars = data.title.split('');
  const subtitleChars = data.subtitle.split('');
  const openProjectText = "open project";
  const openProjectChars = openProjectText.split('');

  return (
    <div 
      ref={containerRef}
      className=" flex items-center justify-start p-4 md:p-8 relative overflow-hidden"
    >
      <div className="text-left relative group w-full max-w-lg">
        <h2 className="text-xl sm:text-1xl md:text-2xl lg:text-3xl xl:text-4xl font-bold mb-1 md:mb-2 leading-none relative" style={{ color: '#3d3d3a' }}>
          <span className="border-b-1 md:border-b-2 pb-1 md:pb-2 relative inline-block" style={{ borderColor: '#3d3d3a' }}>
            {titleChars.map((char, index) => (
              <span
                key={index}
                ref={el => titleCharsRef.current[index] = el}
                className="bg-[#ebe9dc] rounded-lg inline-block transition-transform duration-300 ease-out"
                style={{
                  transform: titleCharPositions[index] ? 
                    `translate(${titleCharPositions[index].x - titleCharPositions[index].baseX}px, ${titleCharPositions[index].y - titleCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </span>
        </h2>
        
        <div className="text-left mt-1 md:mt-2 flex flex-col sm:flex-row items-start sm:items-baseline gap-2 sm:gap-4 md:gap-8 relative">
          <h2 className="text-xl sm:text-1xl md:text-2xl lg:text-3xl xl:text-4xl font-light relative" style={{ color: '#3d3d3a' }}>
            {subtitleChars.map((char, index) => (
              <span
                key={index}
                ref={el => subtitleCharsRef.current[index] = el}
                className="bg-[#ebe9dc] rounded-lg inline-block transition-transform duration-300 ease-out"
                style={{
                  transform: subtitleCharPositions[index] ? 
                    `translate(${subtitleCharPositions[index].x - subtitleCharPositions[index].baseX}px, ${subtitleCharPositions[index].y - subtitleCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </h2>
          
          <span 
            className="text-base sm:text-lg md:text-xl lg:text-1xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out cursor-pointer hover:underline relative"
            style={{ color: '#ff6b35' }}
            onClick={handleProjectOpen}
          >
            {openProjectChars.map((char, index) => (
              <span
                key={index}
                ref={el => openProjectCharsRef.current[index] = el}
                className="bg-[#ebe9dc] rounded-lg inline-block transition-transform duration-300 ease-out "
                style={{
                  transform: openProjectCharPositions[index] ? 
                    `translate(${openProjectCharPositions[index].x - openProjectCharPositions[index].baseX}px, ${openProjectCharPositions[index].y - openProjectCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
};

// Mobile/Touch Interactive Portfolio Item
const MobileInteractivePortfolioItem = ({ 
  data = { title: "Project 1", subtitle: "website", projectUrl: "#" },
  onProjectOpen,
  force = 20,
  falloff = 250,
  scrollIntensity = 0,
  onAnimateCharacters
}) => {
  const [touchPos, setTouchPos] = useState({ x: 0, y: 0 });
  const [isTouching, setIsTouching] = useState(false);
  const [titleCharPositions, setTitleCharPositions] = useState([]);
  const [subtitleCharPositions, setSubtitleCharPositions] = useState([]);
  const [openProjectCharPositions, setOpenProjectCharPositions] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const titleCharsRef = useRef([]);
  const subtitleCharsRef = useRef([]);
  const openProjectCharsRef = useRef([]);

  const handleProjectOpen = (e) => {
    e.stopPropagation();
    if (data.projectUrl) {
      if (onProjectOpen) {
        onProjectOpen(data.projectUrl);
      } else {
        window.open(data.projectUrl, '_blank');
      }
    }
  };

  // Initialize character positions
  const updateCharPositions = useCallback(() => {
    if (!containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    
    const titlePositions = titleCharsRef.current.map((charRef) => {
      if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
      const rect = charRef.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2 - containerRect.left;
      const centerY = rect.top + rect.height / 2 - containerRect.top;
      return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
    });

    const subtitlePositions = subtitleCharsRef.current.map((charRef) => {
      if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
      const rect = charRef.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2 - containerRect.left;
      const centerY = rect.top + rect.height / 2 - containerRect.top;
      return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
    });

    const openProjectPositions = openProjectCharsRef.current.map((charRef) => {
      if (!charRef) return { x: 0, y: 0, baseX: 0, baseY: 0 };
      const rect = charRef.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2 - containerRect.left;
      const centerY = rect.top + rect.height / 2 - containerRect.top;
      return { x: centerX, y: centerY, baseX: centerX, baseY: centerY };
    });

    setTitleCharPositions(titlePositions);
    setSubtitleCharPositions(subtitlePositions);
    setOpenProjectCharPositions(openProjectPositions);
  }, [data.title, data.subtitle]);

  useEffect(() => {
    setTimeout(updateCharPositions, 100);
    window.addEventListener('resize', updateCharPositions);
    return () => window.removeEventListener('resize', updateCharPositions);
  }, [updateCharPositions]);

  // Animation function
  const animateCharacters = useCallback((interactionX, interactionY, intensity = 1, isCircleAttraction = false) => {
    if (!containerRef.current) return;

    const animatePositions = (positions, setPositions, forceMultiplier) => {
      setPositions(prev => prev.map((pos) => {
        const dx = interactionX - pos.baseX;
        const dy = interactionY - pos.baseY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        const maxDistance = isCircleAttraction ? falloff * 1.5 : falloff;
        const maxOffset = force * forceMultiplier * intensity;
        
        if (distance < maxDistance && distance > 0) {
          // Attraction effect for circle, repulsion for touch
          const direction = isCircleAttraction ? -1 : 1;
          const strength = (1 - (distance / maxDistance)) * 0.8;
          const offsetX = direction * (dx / distance) * strength * maxOffset;
          const offsetY = direction * (dy / distance) * strength * maxOffset;
          
          return { ...pos, x: pos.baseX + offsetX, y: pos.baseY + offsetY };
        }
        
        return { ...pos, x: pos.baseX, y: pos.baseY };
      }));
    };

    animatePositions(titleCharPositions, setTitleCharPositions, 1);
    animatePositions(subtitleCharPositions, setSubtitleCharPositions, 0.8);
    animatePositions(openProjectCharPositions, setOpenProjectCharPositions, 0.6);
  }, [titleCharPositions, subtitleCharPositions, openProjectCharPositions, force, falloff]);

  // Smooth reset function
  const smoothResetPositions = useCallback(() => {
    if (isTouching) return;
    
    setTitleCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
    setSubtitleCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
    setOpenProjectCharPositions(prev => prev.map(pos => ({ ...pos, x: pos.baseX, y: pos.baseY })));
  }, [isTouching]);

  // Handle scroll animation from parent
  useEffect(() => {
    if (!containerRef.current) return;
    
    const containerRect = containerRef.current.getBoundingClientRect();
    const isInViewport = containerRect.top < window.innerHeight && containerRect.bottom > 0;
    setIsVisible(isInViewport);
    
    if (scrollIntensity > 0.02 && isInViewport && !isTouching) {
      const viewportCenterX = window.innerWidth / 2 - containerRect.left;
      const viewportCenterY = window.innerHeight / 2 - containerRect.top;
      animateCharacters(viewportCenterX, viewportCenterY, scrollIntensity, true);
    } else if (scrollIntensity === 0 && !isTouching) {
      smoothResetPositions();
    }
  }, [scrollIntensity, animateCharacters, smoothResetPositions, isTouching]);

  // Expose animation function to parent
  useEffect(() => {
    if (onAnimateCharacters) {
      onAnimateCharacters(containerRef.current, animateCharacters);
    }
  }, [onAnimateCharacters, animateCharacters]);

  // Touch events
  useEffect(() => {
    const handleTouchStart = (e) => {
      if (!containerRef.current) return;
      const touch = e.touches[0];
      const containerRect = containerRef.current.getBoundingClientRect();
      const touchX = touch.clientX - containerRect.left;
      const touchY = touch.clientY - containerRect.top;
      
      setTouchPos({ x: touchX, y: touchY });
      setIsTouching(true);
      
      animateCharacters(touchX, touchY, 1.2, false);
    };

    const handleTouchMove = (e) => {
      if (!containerRef.current || !isTouching) return;
      const touch = e.touches[0];
      const containerRect = containerRef.current.getBoundingClientRect();
      const touchX = touch.clientX - containerRect.left;
      const touchY = touch.clientY - containerRect.top;
      
      setTouchPos({ x: touchX, y: touchY });
      animateCharacters(touchX, touchY, 0.8, false);
    };

    const handleTouchEnd = () => {
      setIsTouching(false);
      setTimeout(smoothResetPositions, 150);
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('touchstart', handleTouchStart, { passive: true });
      container.addEventListener('touchmove', handleTouchMove, { passive: true });
      container.addEventListener('touchend', handleTouchEnd, { passive: true });
      
      return () => {
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        container.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isTouching, animateCharacters, smoothResetPositions]);

  const titleChars = data.title.split('');
  const subtitleChars = data.subtitle.split('');
  const openProjectText = "open project";
  const openProjectChars = openProjectText.split('');

  return (
    <div 
      ref={containerRef}
      className="flex items-center justify-start p-4 md:p-8 relative overflow-hidden touch-manipulation"
      style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }}
    >
      <div className="text-left relative group w-full max-w-lg">
        <h2 className="text-xl sm:text-1xl md:text-2xl lg:text-3xl xl:text-4xl font-bold mb-1 md:mb-2 leading-none relative" style={{ color: '#3d3d3a' }}>
          <span className="border-b-1 md:border-b-2 pb-1 md:pb-2 relative inline-block" style={{ borderColor: '#3d3d3a' }}>
            {titleChars.map((char, index) => (
              <span
                key={index}
                ref={el => titleCharsRef.current[index] = el}
                className="bg-[#ebe9dc] inline-block transition-transform duration-300 ease-out"
                style={{
                  transform: titleCharPositions[index] ? 
                    `translate(${titleCharPositions[index].x - titleCharPositions[index].baseX}px, ${titleCharPositions[index].y - titleCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)',
                  willChange: 'transform'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </span>
        </h2>
        
        <div className="text-left mt-1 md:mt-2 flex flex-col sm:flex-row items-start sm:items-baseline gap-2 sm:gap-4 md:gap-8 relative">
          <h2 className="bg-[#ebe9dc] text-xl sm:text-1xl md:text-2xl lg:text-3xl xl:text-4xl font-light relative" style={{ color: '#3d3d3a' }}>
            {subtitleChars.map((char, index) => (
              <span
                key={index}
                ref={el => subtitleCharsRef.current[index] = el}
                className="bg-[#ebe9dc] inline-block transition-transform duration-300 ease-out"
                style={{
                  transform: subtitleCharPositions[index] ? 
                    `translate(${subtitleCharPositions[index].x - subtitleCharPositions[index].baseX}px, ${subtitleCharPositions[index].y - subtitleCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)',
                  willChange: 'transform'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </h2>
          
          <span 
            className="bg-[#ebe9dc] text-base sm:text-lg md:text-xl lg:text-1xl opacity-60 group-active:opacity-100 transition-opacity duration-200 ease-in-out cursor-pointer active:underline relative touch-manipulation"
            style={{ 
              color: '#ff6b35',
              WebkitTapHighlightColor: 'transparent'
            }}
            onClick={handleProjectOpen}
          >
            {openProjectChars.map((char, index) => (
              <span
                key={index}
                ref={el => openProjectCharsRef.current[index] = el}
                className="bg-[#ebe9dc] inline-block transition-transform duration-300 ease-out"
                style={{
                  transform: openProjectCharPositions[index] ? 
                    `translate(${openProjectCharPositions[index].x - openProjectCharPositions[index].baseX}px, ${openProjectCharPositions[index].y - openProjectCharPositions[index].baseY}px)` : 
                    'translate(0px, 0px)',
                  willChange: 'transform'
                }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
};

// Adaptive Portfolio Item
const AdaptivePortfolioItem = ({ scrollIntensity, ...props }) => {
  const isTouchDevice = useDeviceDetection();
  
  return isTouchDevice ? 
    <MobileInteractivePortfolioItem scrollIntensity={scrollIntensity} {...props} /> : 
    <SingleInteractivePortfolioItem {...props} />;
};

// HomePage Image Component
const HomePage_image = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const [animationComplete, setAnimationComplete] = useState(false);
  const [animationStarted, setAnimationStarted] = useState(false);
  const zoomContainerRef = useRef(null);
  const totalImages = 60;
  const frameRate = 24;
  const minPreloadFrames = 2; // Start after loading first 2 frames
  const preloadAhead = 10; // Always keep 10 frames ahead cached

  useEffect(() => {
    const hasPlayedAnimation = sessionStorage.getItem('animationPlayed');
    
    if (hasPlayedAnimation === 'true') {
      setCurrentImageIndex(totalImages - 1);
      setAnimationComplete(true);
    }
  }, [totalImages]);

  useEffect(() => {
    const imageArray = [];
    for (let i = 1; i <= totalImages; i++) {
      const imageNumber = 30000 + i;
      imageArray.push(`https://supabase.horoboro.com/storage/v1/object/public/horoboro-website/website-images/homepage/animated-logo/Animaz${imageNumber}.webp`);
    }
    setImages(imageArray);
  }, [totalImages]);

  // Preload specific frames
  const preloadImages = useCallback((startIndex, endIndex) => {
    const promises = [];
    for (let i = startIndex; i <= Math.min(endIndex, images.length - 1); i++) {
      if (!loadedImages.has(i) && images[i]) {
        const promise = new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            setLoadedImages(prev => new Set(prev).add(i));
            resolve();
          };
          img.onerror = () => resolve(); // Continue even if an image fails
          img.src = images[i];
        });
        promises.push(promise);
      }
    }
    return Promise.all(promises);
  }, [images, loadedImages]);

  // Initial preload of first few frames
  useEffect(() => {
    if (images.length === 0) return;

    const hasPlayedAnimation = sessionStorage.getItem('animationPlayed');
    
    if (hasPlayedAnimation === 'true') {
      // If animation was already played, just load the last frame
      preloadImages(totalImages - 1, totalImages - 1);
    } else {
      // Preload first few frames then start
      preloadImages(0, minPreloadFrames - 1).then(() => {
        setAnimationStarted(true);
      });
      
      // Continue loading the rest in background
      preloadImages(minPreloadFrames, totalImages - 1);
    }
  }, [images, totalImages, preloadImages]);

  // Preload frames ahead of current position during animation
  useEffect(() => {
    if (!animationStarted || animationComplete) return;
    
    // Always preload frames ahead of current position
    const preloadEnd = Math.min(currentImageIndex + preloadAhead, totalImages - 1);
    if (preloadEnd > currentImageIndex) {
      preloadImages(currentImageIndex + 1, preloadEnd);
    }
  }, [currentImageIndex, animationStarted, animationComplete, totalImages, preloadImages]);

  useEffect(() => {
    if (!animationStarted || animationComplete || !zoomContainerRef.current) return;
    
    const container = zoomContainerRef.current;
    container.style.transform = 'scale(0.92)';
    container.style.transition = 'transform 2.5s ease-out';
    void container.offsetWidth;
    
    setTimeout(() => {
      container.style.transform = 'scale(1)';
    }, 50);
  }, [animationStarted, animationComplete]);

  useEffect(() => {
    if (images.length === 0 || !animationStarted || animationComplete) return;

    let currentFrame = 0;
    
    const interval = setInterval(() => {
      if (currentFrame < totalImages - 1) {
        currentFrame++;
        setCurrentImageIndex(currentFrame);
      } else {
        sessionStorage.setItem('animationPlayed', 'true');
        setAnimationComplete(true);
        clearInterval(interval);
      }
    }, 1000 / frameRate);
    
    return () => clearInterval(interval);
  }, [images, animationStarted, animationComplete, totalImages, frameRate]);
  
  const handleReplay = () => {
    setCurrentImageIndex(0);
    setAnimationComplete(false);
    
    // Preload first few frames before restarting
    preloadImages(0, minPreloadFrames - 1).then(() => {
      setAnimationStarted(true);
      
      if (zoomContainerRef.current) {
        zoomContainerRef.current.style.transform = 'scale(0.92)';
        void zoomContainerRef.current.offsetWidth;
        
        setTimeout(() => {
          if (zoomContainerRef.current) {
            zoomContainerRef.current.style.transform = 'scale(1)';
          }
        }, 50);
      }
    });
  };
  
  return (
    <div id="top-section" className="relative flex items-center justify-center min-h-screen">
      <div className="flex border-bg-black">

      </div>

      <div className="text-center w-full max-w-[600px] px-4">        
        <div className="relative w-full h-full max-w-[600px] max-h-[600px] aspect-square mx-auto mb-8 overflow-hidden rounded-lg">
          <div 
            ref={zoomContainerRef}
            className="absolute inset-0 w-full h-full"
          >
            <img
              src="/images/black_logo.png"
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover opacity-0"
            />
            
            {images.length > 0 && images[currentImageIndex] && (
              <img
                src={images[currentImageIndex]}
                alt={`Animation frame ${currentImageIndex + 1}`}
                className="absolute inset-0 w-full h-full object-contain z-10"
              />
            )}
          </div>
        </div>
      </div>
      
      {/* ScrollNudger positioned at bottom center */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20">
        <ScrollNudger />
      </div>
      
      {animationComplete && (
        <button 
          className="absolute bottom-6 right-6 w-6 h-6  transition-all duration-300 flex items-center justify-center group z-20"
          onClick={handleReplay}
        >
          <svg 
            className="w-6 h-6 text-gray-700 group-hover:text-gray-900 transition-colors" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H25" 
            />
          </svg>
        </button>
      )}
      

    </div>

  );
};
// Project Showcase with scroll management
const ProjectShowcase = () => {
  const [scrollIntensity, setScrollIntensity] = useState(0);
  const [showCircle, setShowCircle] = useState(false);
  const isTouchDevice = useDeviceDetection();
  const lastScrollY = useRef(0);
  const animationFrameRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const containerRef = useRef(null);

  const projects = {
    1: {
      name: "New TMMT",
      category: "Website",
      link: "https://new.tmmt.it"
    },
    2: {
      name: "Alessandra Filzoli",
      category: "Website",
      link: "https://alessandrafilzoli.com"
    },
    3: {
      name: "Vorwerk Repair",
      category: "Website",
      link: "https://prestige.vorwerk.repair"
    }
  };

  const handleProjectOpen = (url) => {
    window.open(url, '_blank');
  };

  // Scroll handling for mobile devices
  useEffect(() => {
    if (!isTouchDevice) return;

    const handleScroll = () => {
      if (!containerRef.current) return;
      
      const containerRect = containerRef.current.getBoundingClientRect();
      const isInViewport = containerRect.top < window.innerHeight && containerRect.bottom > 0;
      
      if (!isInViewport) {
        setShowCircle(false);
        setScrollIntensity(0);
        return;
      }
      
      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - lastScrollY.current;
      lastScrollY.current = currentScrollY;
      
      const scrollVelocity = Math.abs(scrollDelta);
      const intensity = Math.min(scrollVelocity * 0.3, 1);
      
      if (intensity > 0.02) {
        setShowCircle(true);
        setScrollIntensity(intensity);
        
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
        
        scrollTimeoutRef.current = setTimeout(() => {
          setScrollIntensity(0);
          setShowCircle(false);
        }, 400);
      }
    };

    const throttledScroll = () => {
      if (animationFrameRef.current) return;
      animationFrameRef.current = requestAnimationFrame(() => {
        handleScroll();
        animationFrameRef.current = null;
      });
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', throttledScroll);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [isTouchDevice]);

  return (
    <div id="detail-section" className=" relative" ref={containerRef}>

    <h1 
      id="latest-projects-heading"
      className="text-xl p-8 sm:text-1xl md:text-1xl lg:text-2xl xl:text-2xl italic leading-none relative text-left" 
      style={{ color: '#3d3d3a' }}
    >
      Latest projects
    </h1>

      {/* Grid of Interactive Portfolio Items */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
        {Object.entries(projects).map(([id, project]) => (
          <AdaptivePortfolioItem
            key={id}
            data={{
              title: project.name,
              subtitle: project.category.toLowerCase(),
              projectUrl: project.link
            }}
            scrollIntensity={scrollIntensity}
            force={20}
            falloff={250}
            onProjectOpen={handleProjectOpen}
          />
        ))}
      </div>
    </div>
  );
};

// Main HomePage Component
const HomePage = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = '';

    };
  }, []);

  return (
    <div className="flex flex-col w-full">
      <ParticleGrid
        className="absolute inset-0 cursor-crosshair"
      />
      <HomePage_image />
      <ProjectShowcase />
      <Footer />

    </div>
  );
};

export default HomePage;